import i18n from "@/src/modules/core/i18n";

/** Shared image/camera toasts for core UI (ImagePicker, CameraCapture). */
export function tMediaUploadOffline(): string {
  return i18n.t("media.upload_offline", {ns: "common"});
}

export function tMediaCaptureFailed(): string {
  return i18n.t("media.capture_failed", {ns: "common"});
}

export function tMediaFlashEnableFailed(): string {
  return i18n.t("media.flash_enable_failed", {ns: "common"});
}

export function tMediaFlashOnCapture(): string {
  return i18n.t("media.flash_on_capture", {ns: "common"});
}
